// extracted by mini-css-extract-plugin
module.exports = {"container":"Breadcrumb_container__fPEmu","crumb":"Breadcrumb_crumb__1vU3j"};